import React from 'react';
import {
    EssencePageContainer,
    EssenceHero,
    HeroSubtitle,
    EssenceSection,
    EssenceContent,
    SectionHeading,
    SectionText,
    EssenceImageWrapper,
    EssenceImage
} from './EssencePage.styled';
import { SectionTitle } from './ContactPage.styled';
import { SEOHead } from '../components/SEOHead';

import yoImage from '../assets/images/esscence/YO.jpg';
import crazyPlantPotsImage from '../assets/images/esscence/crazyplantpots.jpg';
import logoImage from '../assets/images/esscence/LogoDuoaColor.png';

function EssencePage() {
    return (
        <EssencePageContainer>
            <SEOHead
                title="Nuestra Esencia - Duo a Color Punch Needle"
                description="Conoce la historia de Duo a Color (duoacolor). Especialistas en punch needle y arte textil personalizado. Creamos piezas únicas con amor."
                path="/our-essence"
            />
            <EssenceHero>
                <SectionTitle>Nuestra Esencia</SectionTitle>
                <HeroSubtitle>El Corazón de Duo a Color</HeroSubtitle>
            </EssenceHero>

            {/* Sección 1: El origen de una pasión - Imagen izquierda */}
            <EssenceSection delay="0.2s">
                <EssenceImageWrapper>
                    <EssenceImage
                        src={yoImage}
                        alt="Yhanmary, fundadora de Duo a Color"
                    />
                </EssenceImageWrapper>
                <EssenceContent>
                    <SectionHeading>El origen de una pasión</SectionHeading>
                    <SectionText>
                        Detrás de cada trazo y cada puntada está Yhanmary, una caraqueña de
                        nacimiento y española de corazón, cuya vida ha estado siempre guiada
                        por el hilo de las artes. Mi viaje comenzó desde muy pequeña, alimentando
                        una curiosidad infinita que me llevó a formarme profesionalmente como
                        Orfebre/Joyera.
                    </SectionText>
                    <SectionText>
                        Esa disciplina me enseñó que el valor de un objeto no reside solo en su
                        material, sino en la historia y la técnica que lo moldean. Mi espíritu
                        emprendedor ha sido mi motor constante, buscando siempre nuevas formas
                        de dar vida a la belleza a través de las manos.
                    </SectionText>
                </EssenceContent>
            </EssenceSection>

            {/* Sección 2: CrazyPlantPots - Imagen derecha */}
            <EssenceSection reverse delay="0.4s">
                <EssenceImageWrapper>
                    <EssenceImage
                        src={crazyPlantPotsImage}
                        alt="Macetas artesanales CrazyPlantPots"
                    />
                </EssenceImageWrapper>
                <EssenceContent>
                    <SectionHeading>Donde todo floreció: CrazyPlantPots</SectionHeading>
                    <SectionText>
                        Antes de que Duo a Color tomara su forma actual, el color comenzó a brotar
                        a través de CrazyPlantPots. Esta marca nació de la magia de transformar
                        el barro y el cemento en lienzos vivos. Nos dedicábamos a la creación
                        de macetas artesanales, diseñando moldes propios y dándoles personalidad
                        mediante la pintura a mano.
                    </SectionText>
                    <SectionText>
                        Fue nuestra primera gran ventana al mundo del diseño personalizado.
                        Hoy, con mucho orgullo, CrazyPlantPots ha evolucionado para convertirse
                        en una de las líneas de producto estrella de Duo a Color, manteniendo su
                        esencia vibrante y artesanal.
                    </SectionText>
                </EssenceContent>
            </EssenceSection>

            {/* Sección 3: Duoacolor - Imagen izquierda */}
            <EssenceSection delay="0.6s">
                <EssenceImageWrapper>
                    <EssenceImage
                        src={logoImage}
                        alt="Logo de Duo a Color - Tu historia, nuestra pieza única"
                    />
                </EssenceImageWrapper>
                <EssenceContent>
                    <SectionHeading>Duo a Color: Tu historia, nuestra pieza única</SectionHeading>
                    <SectionText>
                        Duo a Color surge con una misión clara: crear una experiencia inolvidable
                        para quienes, como tú, tienen una historia que contar. No hacemos simples
                        accesorios; convertimos tus vivencias y emociones en piezas únicas para
                        lucir o decorar tu hogar.
                    </SectionText>
                    <SectionText>
                        Nuestra especialidad es la técnica del Punch Needle, ese "bordado en
                        relieve" que aporta una textura mágica, y que a menudo combinamos con
                        la precisión de la pintura para lograr acabados sorprendentes en totebags,
                        cojines y alfombras.
                    </SectionText>
                    <SectionText>
                        Nuestra historia sigue evolucionando, innovando constantemente en materiales
                        y técnicas para ofrecerte siempre algo nuevo, algo especial, algo que solo
                        tú puedas tener. Porque tu historia es única, y tu pieza también debería serlo.
                    </SectionText>
                </EssenceContent>
            </EssenceSection>
        </EssencePageContainer>
    );
}

export default EssencePage;
